import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, ViewChild } from "@angular/core";
import { PageProdutoComponent } from "../../page-produto.component";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import Panzoom from "@panzoom/panzoom";
declare var $: any;
@Component({
  selector: "app-produto-grade",
  templateUrl: "./produto-grade.component.html",
  styleUrls: ["./produto-grade.component.css"],
})
export class ProdutoGradeComponent implements OnDestroy, AfterViewInit{
  imagemSelecionada = "";
  public SITE: any;
  public theme: any;
  mobile = false;
  private dragX = 0;
  private dragY = 0;
  private dragging = false;
  private swiped = false;
  private thumbDragX = 0;
  private thumbScrollLeft = 0;
  private thumbDragging = false;
  private thumbMoved = false;
  color = "black";
  @ViewChild("thumbsStrip") thumbsStrip?: ElementRef<HTMLElement>;
  
   @ViewChild('panzoom') panzoomElement!: ElementRef<HTMLElement>;

  ngAfterViewInit() {
    const panzoom = Panzoom(this.panzoomElement.nativeElement, {
      minScale: 1,
      maxScale: 5,
      contain: 'outside',
      animate: true
    });

    this.panzoomElement.nativeElement.parentElement!
      .addEventListener('wheel', panzoom.zoomWithWheel);
  }
  private zoomEl: HTMLDivElement | null = null;

  constructor(public page: PageProdutoComponent) {
    this.SITE = Configuracoes.SITE
    this.theme = Configuracoes.themes.filter(
      (i) => i.id == Configuracoes.SITE.theme
    )[0];
    this.mobile = window.innerWidth < 992;
  }

  @HostListener("window:resize")
  onResize() {
    this.mobile = window.innerWidth < 992;
  }

  get colunasGrade(): string {
    const n = this.page.tamanhos?.length || 0;
    const tamanhos = `repeat(${n}, 104px)`;
    if (n > 0 && n < 3) {
      return `minmax(0, 1fr) ${tamanhos} minmax(0, 1fr)`;
    }
    return `minmax(120px, .5fr) ${tamanhos}`;
  }

  get fotosSlider(): any[] {
    return this.mobile ? this.page.fotosDaCor : this.page.fotosVisiveisDaCor;
  }

  fotoIndex(visibleIndex: number): number {
    return this.mobile ? visibleIndex : this.page.fotoJanela + visibleIndex;
  }

  onPhotoPointerDown(event: PointerEvent) {
    if (!this.mobile || (event.pointerType === "mouse" && event.button !== 0)) {
      return;
    }
    this.dragging = true;
    this.swiped = false;
    this.dragX = event.clientX;
    this.dragY = event.clientY;
    (event.currentTarget as HTMLElement).setPointerCapture(event.pointerId);
  }

  onPhotoPointerUp(event: PointerEvent) {
    if (!this.mobile || !this.dragging) {
      return;
    }
    this.dragging = false;
    const dx = event.clientX - this.dragX;
    const dy = event.clientY - this.dragY;
    if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) {
      return;
    }
    this.swiped = true;
    const total = this.page.fotosDaCor.length;
    if (dx < 0 && this.page.fotoAtiva < total - 1) {
      this.page.selecionarFoto(this.page.fotoAtiva + 1);
    } else if (dx > 0 && this.page.fotoAtiva > 0) {
      this.page.selecionarFoto(this.page.fotoAtiva - 1);
    }
    setTimeout(() => this.scrollActiveThumb());
  }

  onThumbsPointerDown(event: PointerEvent) {
    if (!this.mobile || !this.thumbsStrip || (event.pointerType === "mouse" && event.button !== 0)) {
      return;
    }
    this.thumbDragging = true;
    this.thumbMoved = false;
    this.thumbDragX = event.clientX;
    this.thumbScrollLeft = this.thumbsStrip.nativeElement.scrollLeft;
    this.thumbsStrip.nativeElement.setPointerCapture(event.pointerId);
  }

  onThumbsPointerMove(event: PointerEvent) {
    if (!this.thumbDragging || !this.thumbsStrip) {
      return;
    }
    const dx = event.clientX - this.thumbDragX;
    if (Math.abs(dx) > 5) {
      this.thumbMoved = true;
    }
    this.thumbsStrip.nativeElement.scrollLeft = this.thumbScrollLeft - dx;
  }

  onThumbsPointerUp() {
    const moved = this.thumbMoved;
    this.thumbDragging = false;
    if (moved) {
      this.snapThumbs();
    }
  }

  onThumbClick(event: Event, index: number) {
    if (this.thumbMoved) {
      event.preventDefault();
      event.stopPropagation();
      this.thumbMoved = false;
      return;
    }
    this.page.selecionarFoto(index);
  }

  onPhotoClick(src) {
    console.log(src)
    this.imagemSelecionada = src;
    $("#imageModal").modal("show");
    // if (this.mobile) {
    //   this.abrirFoto(foto.value);
    //   return;
    // }
    // this.abrirFotoDesktop(foto.value);
  }
  
   fechaModal() {
    $("#imageModal").modal("hide");
  }

  @HostListener("document:keydown.escape")
  onEscape() {
    this.fecharFoto();
  }

  ngOnDestroy() {
    this.fecharFoto();
  }

  // private estiloFechar(): string {
  //   const cor = this.SITE?.backgroundColorSliderSuperior || "#111";
  //   return (
  //     "position:absolute;top:8px;right:8px;z-index:2;width:36px;height:36px;border:0;border-radius:50%;" +
  //     `background:${cor};color:#fff;font-size:26px;line-height:1;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.28);`
  //   );
  // }

  // private abrirFoto(src: string) {
  //   this.fecharFoto();
  //   const overlay = document.createElement("div");
  //   overlay.setAttribute("role", "dialog");
  //   overlay.setAttribute("aria-modal", "true");
  //   overlay.style.cssText =
  //     "position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.4);touch-action:none;";

  //   const frame = document.createElement("div");
  //   frame.style.cssText = "position:relative;overflow:hidden;touch-action:none;";

  //   const close = document.createElement("button");
  //   close.type = "button";
  //   close.setAttribute("aria-label", "Fechar");
  //   close.textContent = "×";
  //   close.style.cssText = this.estiloFechar();
  //   close.addEventListener("pointerdown", (event) => event.stopPropagation());
  //   close.addEventListener("click", (event) => {
  //     event.stopPropagation();
  //     this.fecharFoto();
  //   });

  //   const img = document.createElement("img");
  //   img.src = src;
  //   img.alt = this.page.product?.descricao || "";
  //   img.draggable = false;
  //   img.style.cssText =
  //     "display:block;width:100%;height:100%;object-fit:contain;transform-origin:center center;user-select:none;touch-action:none;";

  //   const ponteiros = new Map<number, { x: number; y: number }>();
  //   let escala = 1;
  //   let escalaInicial = 1;
  //   let distanciaInicial = 0;

  //   const distancia = () => {
  //     const pontos = Array.from(ponteiros.values());
  //     if (pontos.length < 2) {
  //       return 0;
  //     }
  //     return Math.hypot(pontos[0].x - pontos[1].x, pontos[0].y - pontos[1].y);
  //   };

  //   const aplicarZoom = (scale: number, origemX: number, origemY: number) => {
  //     const rect = frame.getBoundingClientRect();
  //     const x = rect.width ? ((origemX - rect.left) / rect.width) * 100 : 50;
  //     const y = rect.height ? ((origemY - rect.top) / rect.height) * 100 : 50;
  //     img.style.transformOrigin = `${x}% ${y}%`;
  //     img.style.transform = `scale(${scale})`;
  //   };

  //   const encaixar = () => {
  //     const maxW = Math.max(1, overlay.clientWidth - 32);
  //     const maxH = Math.max(1, overlay.clientHeight - 32);
  //     const naturalW = img.naturalWidth || maxW;
  //     const naturalH = img.naturalHeight || maxH;
  //     const ratio = Math.min(maxW / naturalW, maxH / naturalH);
  //     frame.style.width = Math.max(1, Math.round(naturalW * ratio)) + "px";
  //     frame.style.height = Math.max(1, Math.round(naturalH * ratio)) + "px";
  //   };

  //   frame.addEventListener("pointerdown", (event) => {
  //     if (event.pointerType === "mouse") {
  //       return;
  //     }
  //     ponteiros.set(event.pointerId, { x: event.clientX, y: event.clientY });
  //     frame.setPointerCapture(event.pointerId);
  //     if (ponteiros.size === 2) {
  //       escalaInicial = escala;
  //       distanciaInicial = distancia();
  //     }
  //   });
  //   frame.addEventListener("pointermove", (event) => {
  //     if (!ponteiros.has(event.pointerId)) {
  //       return;
  //     }
  //     ponteiros.set(event.pointerId, { x: event.clientX, y: event.clientY });
  //     if (ponteiros.size < 2 || distanciaInicial <= 0) {
  //       return;
  //     }
  //     const pontos = Array.from(ponteiros.values());
  //     escala = Math.min(4, Math.max(1, escalaInicial * (distancia() / distanciaInicial)));
  //     aplicarZoom(escala, (pontos[0].x + pontos[1].x) / 2, (pontos[0].y + pontos[1].y) / 2);
  //   });
  //   const soltar = (event: PointerEvent) => {
  //     ponteiros.delete(event.pointerId);
  //     if (ponteiros.size < 2) {
  //       escalaInicial = escala;
  //       distanciaInicial = 0;
  //     }
  //   };
  //   frame.addEventListener("pointerup", soltar);
  //   frame.addEventListener("pointercancel", soltar);

  //   if (img.complete) {
  //     requestAnimationFrame(encaixar);
  //   } else {
  //     img.addEventListener("load", () => requestAnimationFrame(encaixar));
  //   }

  //   overlay.addEventListener("click", (clickEvent) => {
  //     if (clickEvent.target === overlay) {
  //       this.fecharFoto();
  //     }
  //   });

  //   frame.append(img, close);
  //   overlay.append(frame);
  //   document.body.appendChild(overlay);
  //   document.body.style.overflow = "hidden";
  //   this.zoomEl = overlay;
  // }

  // private abrirFotoDesktop(src: string) {
  //   this.fecharFoto();
  //   const overlay = document.createElement("div");
  //   overlay.setAttribute("role", "dialog");
  //   overlay.setAttribute("aria-modal", "true");
  //   overlay.style.cssText =
  //     "position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.4);";

  //   const frame = document.createElement("div");
  //   frame.style.cssText = "position:relative;max-width:92vw;max-height:calc(100vh - 32px);";

  //   const close = document.createElement("button");
  //   close.type = "button";
  //   close.setAttribute("aria-label", "Fechar");
  //   close.textContent = "×";
  //   close.style.cssText = this.estiloFechar();
  //   close.addEventListener("click", (event) => {
  //     event.stopPropagation();
  //     this.fecharFoto();
  //   });

  //   const stage = document.createElement("div");
  //   stage.style.cssText =
  //     "position:relative;overflow:hidden;max-width:92vw;max-height:calc(100vh - 32px);cursor:zoom-in;";

  //   const img = document.createElement("img");
  //   img.src = src;
  //   img.alt = this.page.product?.descricao || "";
  //   img.draggable = false;
  //   img.style.cssText =
  //     "display:block;max-width:92vw;max-height:calc(100vh - 32px);width:auto;height:auto;object-fit:contain;transform-origin:center center;user-select:none;";

  //   const badge = document.createElement("span");
  //   badge.textContent = "1x";
  //   badge.style.cssText =
  //     "position:absolute;left:8px;bottom:8px;z-index:2;padding:4px 10px;border-radius:999px;background:rgba(255,255,255,.92);color:#111;font-size:12px;font-weight:700;";

  //   let nivel = 1;

  //   const encaixar = () => {
  //     const width = img.offsetWidth;
  //     const height = img.offsetHeight;
  //     if (!width || !height) {
  //       return;
  //     }
  //     stage.style.width = width + "px";
  //     stage.style.height = height + "px";
  //     img.style.maxWidth = "none";
  //     img.style.maxHeight = "none";
  //     img.style.width = "100%";
  //     img.style.height = "100%";
  //   };

  //   const aplicar = (scale: number, clientX: number, clientY: number) => {
  //     const rect = stage.getBoundingClientRect();
  //     const x = rect.width ? ((clientX - rect.left) / rect.width) * 100 : 50;
  //     const y = rect.height ? ((clientY - rect.top) / rect.height) * 100 : 50;
  //     img.style.transformOrigin = `${x}% ${y}%`;
  //     img.style.transform = `scale(${scale})`;
  //     badge.textContent = `${scale}x`;
  //     stage.style.cursor = nivel >= 4 ? "zoom-out" : "zoom-in";
  //   };

  //   const restaurar = () => {
  //     img.style.transform = "scale(1)";
  //     img.style.transformOrigin = "center center";
  //     badge.textContent = "1x";
  //     stage.style.cursor = "zoom-in";
  //   };

  //   if (img.complete) {
  //     requestAnimationFrame(encaixar);
  //   } else {
  //     img.addEventListener("load", () => requestAnimationFrame(encaixar));
  //   }

  //   stage.addEventListener("mousemove", (event) => {
  //     aplicar(nivel === 1 ? 2 : nivel, event.clientX, event.clientY);
  //   });
  //   stage.addEventListener("mouseleave", () => {
  //     if (nivel === 1) {
  //       restaurar();
  //     }
  //   });
  //   stage.addEventListener("click", (event) => {
  //     event.stopPropagation();
  //     nivel = nivel >= 4 ? 1 : nivel + 1;
  //     if (nivel === 1) {
  //       restaurar();
  //       return;
  //     }
  //     aplicar(nivel, event.clientX, event.clientY);
  //   });

  //   overlay.addEventListener("click", (event) => {
  //     if (event.target === overlay) {
  //       this.fecharFoto();
  //     }
  //   });

  //   stage.appendChild(img);
  //   frame.append(stage, close, badge);
  //   overlay.append(frame);
  //   document.body.appendChild(overlay);
  //   document.body.style.overflow = "hidden";
  //   this.zoomEl = overlay;
  // }

  private fecharFoto() {
    if (!this.zoomEl) {
      return;
    }
    this.zoomEl.remove();
    this.zoomEl = null;
    document.body.style.overflow = "";
  }

  private thumbStep(root: HTMLElement): number {
    const thumb = root.querySelector(".mv2-thumb") as HTMLElement | null;
    if (!thumb) {
      return 0;
    }
    const styles = getComputedStyle(root);
    const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
    return thumb.offsetWidth + gap;
  }

  private snapThumbs() {
    const root = this.thumbsStrip?.nativeElement;
    if (!root) {
      return;
    }
    const step = this.thumbStep(root);
    if (step <= 0) {
      return;
    }
    const max = Math.max(0, root.scrollWidth - root.clientWidth);
    const left = Math.min(max, Math.max(0, Math.round(root.scrollLeft / step) * step));
    root.scrollTo({ left, behavior: "smooth" });
  }

  private scrollActiveThumb() {
    const root = this.thumbsStrip?.nativeElement;
    if (!root) {
      return;
    }
    const thumbs = Array.from(root.querySelectorAll(".mv2-thumb"));
    const index = thumbs.findIndex((item) => item.classList.contains("active"));
    const step = this.thumbStep(root);
    if (index < 0 || step <= 0) {
      return;
    }
    const maxIndex = Math.max(0, thumbs.length - 4);
    const max = Math.max(0, root.scrollWidth - root.clientWidth);
    const left = Math.min(max, Math.min(index, maxIndex) * step);
    root.scrollTo({ left, behavior: "smooth" });
  }
}
